import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SeoProps } from './models';

const site = {
  defaultTitle: 'ETF Global',
  titleTemplate: '',
  defaultDescription: 'ETF Global',
  siteUrl: '',
  defaultImage: '',
  twitterUsername: '',
};

const Seo: FC<SeoProps> = ({
  title,
  description,
  keywords,
  og_title,
  og_site_name,
  og_description,
  og_image,
  og_type,
}) => {
  const { pathname } = useLocation();

  const { defaultTitle, titleTemplate, defaultDescription, twitterUsername } =
    site;

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    og_image: og_image ?? '',
    url: pathname ?? '',
    og_title: og_title ?? '',
    keywords: keywords ?? '',
    og_site_name: og_site_name ?? '',
    og_description: og_description ?? '',
    og_type: og_type ?? '',
  };

  return (
    <Helmet
      title={seo.title}
      titleTemplate={titleTemplate}
      htmlAttributes={{ lang: 'en' }}
    >
      {seo.description && <meta name="description" content={seo.description} />}
      {(og_type ? true : null) && <meta name="keywords" content={keywords} />}

      {seo.og_image && <meta name="image" content={seo.og_image} />}
      {seo.url && <meta property="og:url" content={seo.url} />}

      {(seo.og_type ? true : null) && (
        <meta property="og:type" content={seo.og_type} />
      )}
      {(og_site_name ? true : null) && (
        <meta property="og:site_name" content={og_site_name} />
      )}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      {seo.og_image && <meta property="og:image" content={seo.og_image} />}

      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}
      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.og_image && <meta name="twitter:image" content={seo.og_image} />}
    </Helmet>
  );
};

export default Seo;
